// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0f2f5f',
        },
        secondary: {
            main: '#19a7ce',
        },
        success: {
            main: '#1b9c85',
        },
        background: {
            paper: '#ffffff',
            default: '#f5f8fc',
        },
        text: {
            primary: '#102033',
            secondary: '#52657a',
        },
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", "Roboto", "Arial", sans-serif',
        h1: {
            fontWeight: 800,
            letterSpacing: 0,
        },
        h2: {
            fontWeight: 800,
            letterSpacing: 0,
        },
        h3: {
            fontWeight: 800,
            letterSpacing: 0,
        },
        h4: {
            fontWeight: 750,
            letterSpacing: 0,
        },
        h5: {
            fontWeight: 700,
            letterSpacing: 0,
        },
        h6: {
            fontWeight: 700,
        },
        button: {
            fontWeight: 700,
            textTransform: 'none',
            letterSpacing: 0,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid rgba(15, 47, 95, 0.08)',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: 'none',
                },
            },
        },
    },
});

export default theme;
